var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIndexIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Universe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.Index---Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-IB---Create-New-Index---08",
    transform: "translate(-156.000000, -153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(110.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Index-Icons",
    transform: "translate(46.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "I",
    fill: "#0039CB",
    fillRule: "nonzero",
    points: "21.56 44.1 21.56 5.88 28.42 5.88 28.42 44.1"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIndexIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Index_Icon.82857ddb.svg";
export { ForwardRef as ReactComponent };